/**
 * GameGrid — the 6x5 grid of tiles.
 */
import React from 'react';
import Row from './Row';
import { useSelector } from 'react-redux';
import { MAX_GUESSES, GAME_STATUS } from '../../utils/constants';

const GameGrid = () => {
  const { guesses, evaluations, currentGuess, currentRow, shakeRow, status } =
    useSelector((state) => state.game);

  const rows = [];
  for (let i = 0; i < MAX_GUESSES; i++) {
    if (i < guesses.length) {
      // Completed row
      rows.push(
        <Row
          key={i}
          guess={guesses[i]}
          evaluation={evaluations[i]}
          isWinRow={
            status === GAME_STATUS.WON && i === guesses.length - 1
          }
        />
      );
    } else if (i === currentRow) {
      // Current input row
      rows.push(
        <Row
          key={i}
          guess={currentGuess}
          isCurrentRow
          shakeRow={shakeRow}
        />
      );
    } else {
      // Empty future row
      rows.push(<Row key={i} />);
    }
  }

  return (
    <div className="flex flex-col gap-1.5 items-center py-2">{rows}</div>
  );
};

export default GameGrid;
